// Ordenação da listagem de chamados pelo clique no cabeçalho.
//
// A ordenação é do SERVIDOR, não do navegador. A lista é scroll infinito:
// ordenar só o que já desceu mostraria "o mais antigo" que na verdade é o mais
// antigo da página carregada -- pior que não ordenar, porque parece certo. Com
// 262 mil chamados no arquivo histórico isso deixou de ser detalhe.
//
// Por isso a lista de colunas ordenáveis é curta e não é arbitrária: cada uma
// existe em `TicketController::COLUNAS_ORDENAVEIS` e tem índice que começa por
// `tenant_id`. Acrescentar uma aqui sem acrescentar lá não ordena nada -- o
// backend ignora o que não conhece e cai no padrão.
//
// Ficaram DE FORA, de propósito:
//
//   assunto      índice de varchar(255) caro, para um uso que ninguém tem;
//   responsável  o que se quer é o NOME, que mora em `users`;
//   cliente      idem, mora em `companies`;
//   tempo atend. não é coluna: é calculado em PHP depois da consulta.

/**
 * Coluna da tela -> coluna que o backend aceita em `sort_by`.
 *
 * Os nomes da esquerda são os `field` das colunas, que variam entre a listagem
 * padrão e a montada por filtro salvo (`status` numa, `status_id` na outra).
 * A coluna de protocolo tem `field: 'id'` mas MOSTRA `number` -- e é por
 * `number` que ela ordena, senão a ordem seria a global em vez da da empresa.
 */
export const ORDENACAO_POR_COLUNA = {
  id: 'number',
  status: 'status_id',
  status_id: 'status_id',
  priority: 'priority',
  created_at: 'created_at',
  updated_at: 'updated_at',
  resolved_at: 'resolved_at',
};

/**
 * A coluna ordena? Devolve a chave para o backend, ou null.
 *
 * @param {string} field `field` da coluna
 * @returns {string|null}
 */
export const chaveDeOrdenacao = (field) => ORDENACAO_POR_COLUNA[field] || null;

/**
 * O que acontece ao clicar num cabeçalho.
 *
 * Três estados, e o terceiro não é enfeite: clicar de novo VOLTA ao padrão.
 * Enquanto há ordenação escolhida a lista vem inteira do servidor; sem ela, a
 * tela usa o caminho de sempre (ativos em memória + finalizados sob demanda).
 * Sem o terceiro clique não haveria como voltar para esse caminho a não ser
 * recarregando a página.
 *
 * O primeiro clique é DESCENDENTE porque é o que se quer em todas elas: os
 * mais recentes, os mais urgentes, os resolvidos por último.
 *
 * @param {{by: string, dir: string}|null} atual ordenação em vigor
 * @param {string} chave coluna clicada, já traduzida
 * @returns {{by: string, dir: string}|null} null = voltar ao padrão
 */
export const proximaOrdenacao = (atual, chave) => {
  if (!chave) return atual;

  if (!atual || atual.by !== chave) {
    return { by: chave, dir: 'desc' };
  }

  if (atual.dir === 'desc') {
    return { by: chave, dir: 'asc' };
  }

  return null;
};

/**
 * Como a coluna deve aparecer no cabeçalho.
 *
 * @param {{by: string, dir: string}|null} atual
 * @param {string} field `field` da coluna
 * @returns {{ordenavel: boolean, ativa: boolean, direcao: string|null}}
 */
export const estadoDaColuna = (atual, field) => {
  const chave = chaveDeOrdenacao(field);

  if (!chave) {
    return { ordenavel: false, ativa: false, direcao: null };
  }

  const ativa = Boolean(atual) && atual.by === chave;

  return { ordenavel: true, ativa, direcao: ativa ? atual.dir : null };
};
